import PropTypes from 'prop-types';
import React from 'react';

const SwitchButton = props => {
  const {id, name, onClick, value} = props;
  return (
    <button
      aria-checked={value}
      className='control__input btn--switch'
      id={id}
      name={name}
      onClick={() => onClick(name, !value)}
      role='switch'
      type='button'
    />
  );
};

SwitchButton.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  onClick: PropTypes.func,
  value: PropTypes.bool
};

export default SwitchButton;
